import React from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import Icon from '../ui/Icon';
import Avatar from '../ui/Avatar';
import ZapMark from '../ui/ZapMark';
import { STUDENT_NAV, headerContext, isNavActive } from './studentNav';
import { useStudent } from './StudentContext';
import { getUser } from '../../utils/authUtil';

/**
 * The student app bar. Left: the brand (on a tab) or a back button + the screen name (on a secondary screen).
 * Right: notifications bell (unread badge) and the avatar, which opens the profile sheet.
 * From 900px the four destinations appear as tabs in the bar and the bottom navigation is hidden.
 */
export default function AppHeader() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const user = getUser();
  const { player, unread, openProfile } = useStudent();
  const ctx = headerContext(pathname);
  const isBack = !!ctx.back;

  const goBack = () => {
    // history.state.idx > 0 means there is somewhere in-app to go back to; otherwise use the logical parent.
    if (window.history.state && window.history.state.idx > 0) navigate(-1);
    else navigate(ctx.back, { replace: true });
  };

  return (
    <header className="z-appbar">
      <div className="z-appbar-inner">
        <div className="z-appbar-left">
          {isBack ? (
            <button type="button" className="z-appbar-back" onClick={goBack} aria-label="Back">
              <Icon name="chevron-left" size={24} />
            </button>
          ) : (
            <Link to="/student/dashboard" className="z-appbar-brand" aria-label="Zaptude home">
              <ZapMark size={30} />
            </Link>
          )}
          {ctx.title ? <h1 className="z-appbar-title">{ctx.title}</h1> : <span className="z-appbar-wordmark">Zaptude</span>}
        </div>

        <nav className="z-topnav" aria-label="Primary">
          {STUDENT_NAV.map(item => (
            <NavLink key={item.path} to={item.path} className={`z-topnav-item${isNavActive(item, pathname) ? ' active' : ''}`} aria-current={isNavActive(item, pathname) ? 'page' : undefined}>
              <Icon name={item.icon} size={18} /> {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="z-appbar-right">
          <Link to="/student/notifications" className="z-appbar-icon" aria-label={unread ? `Notifications, ${unread} unread` : 'Notifications'}>
            <Icon name="notification" size={22} />
            {unread > 0 && <span className="z-appbar-badge" aria-hidden="true">{unread > 9 ? '9+' : unread}</span>}
          </Link>
          <button type="button" className="z-appbar-avatar" onClick={openProfile} aria-label="Open your profile menu" aria-haspopup="dialog">
            <Avatar avatarId={player?.avatar_id} name={user?.name} size={36} />
          </button>
        </div>
      </div>
    </header>
  );
}
